import React, { useState, useEffect } from "react";
import { CustomInput } from 'reactstrap';
import { constants } from '../../types/constants';

const RepSwitchCell = ({
  value: initialValue,
  row: { index, original },
  column: { id },
  updateMyData
}) => {
  const [value, setValue] = useState(!!initialValue);

  const onChange = (e) => {
    // setValue(e.target.checked);
    // console.log(index, id, e.target.checked, original.STATUT);
    if(/*id === "replaced" && */original.STATUT === constants.STATUT_ENC_RECUPERE)
      return
    updateMyData(index, id, e.target.checked);
  };

  useEffect(() => {
    setValue(!!initialValue);
  }, [initialValue]);

  useEffect(() => {
    if(!!original.replacer && !!original.replaced)
      updateMyData(index, "replaced", false)
  }, [original.replacer]);

  useEffect(() => {
    if(!!original.replaced && !!original.replacer)
      updateMyData(index, "replacer", false)
  }, [original.replaced]);

  return <CustomInput type="switch" id={`rep_${id}_${index}`} name={`rep_${id}_${index}Switch`} className={id === "replaced" ? "switchDanger" : ""} checked={value} onChange={onChange} />
};

export default RepSwitchCell;
